export default "__VITE_ASSET__Do22Iew___"